import type { Toast, ToastType } from '../types/toast';

export function createToastKey(
  type: ToastType,
  title: string,
  description?: string,
): string {
  return `${type}|${title}|${description ?? ''}`;
}

export function hasDuplicateToast(
  toasts: Toast[],
  type: ToastType,
  title: string,
  description?: string,
): boolean {
  const key = createToastKey(type, title, description);
  return toasts.some(
    (toast) =>
      createToastKey(toast.type, toast.title, toast.description) === key,
  );
}

export function createToastId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `toast-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
